// extracted by css-extract-rspack-plugin
export default {"placeholder":"_4d51afed","additionalBlur":"_61f853be"};